import React, {useMemo} from "react";
import {Card, CardActions, CardContent} from "@mui/material";
import {CardData, CardTitle, UserAvatar} from "@atttomyx/react-components";
import {datetime, formatters} from "@atttomyx/shared-utils";
import {NODE_ANONYMOUS} from "../../constants";

const OfferingCard = (props) => {
    const {idToNode, offering, filters, children} = props;

    const node = useMemo(() => {
        const contact = idToNode ? idToNode[offering.nodeId] : null;

        return contact ? contact : NODE_ANONYMOUS;
    }, [idToNode, offering.nodeId]);

    return <Card className="offering-card" raised={true}>
        <CardContent>
            <CardTitle>
                {idToNode ? <UserAvatar user={node} mode="right"/> : "Offering"}
            </CardTitle>
            <CardData
                filters={filters}
                data={offering}
                keyToMetadata={{
                    category: {
                        title: "Category",
                    },
                    type: {
                        title: "Type",
                    },
                    amount: {
                        title: "Amount",
                        formatter: formatters.usDollars,
                    },
                    date: {
                        title: "Date",
                        formatter: datetime.getPrettyDate,
                    },
                }}
            />
        </CardContent>
        <CardActions disableSpacing={true}>
            {children}
        </CardActions>
    </Card>
}

export default OfferingCard;
